export default __webpack_public_path__ + "static/media/privacy.eade05b6.svg";